const SvgModes = (props) => (
  <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-1h18v18H-1z" />
      <path
        d="M10.586 1.5a1.496 1.496 0 0 0 0 1.002H0V1.5h10.586zm2.828 0H16v1.002h-2.586a1.496 1.496 0 0 0 0-1.002z"
        fill="currentColor"
      />
      <path
        d="M10.5 2.001a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3.001 0z"
        stroke="currentColor"
        strokeWidth={1.002}
      />
      <path
        d="M2.586 7.5a1.496 1.496 0 0 0 0 1.002H0V7.5h2.586zm2.828 0H16v1.002H5.414a1.496 1.496 0 0 0 0-1.002z"
        fill="currentColor"
      />
      <path
        d="M2.5 8.001a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3.001 0z"
        stroke="currentColor"
        strokeWidth={1.002}
      />
      <path
        d="M7.586 13.5a1.496 1.496 0 0 0 0 1.002H0V13.5h7.586zm2.828 0H16v1.002h-5.586a1.496 1.496 0 0 0 0-1.002z"
        fill="currentColor"
      />
      <path
        d="M7.5 14.001a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3.001 0z"
        stroke="currentColor"
        strokeWidth={1.002}
      />
    </g>
  </svg>
)

export default SvgModes
